{
    "search": "Search",
    "closePanel": "Close panel",
    "predefined": {
        "predefinedText": "Predefined Text",
        "filter": "Filter",
        "blank": "<Blank>"
    },
    "library": {
        "textLibrary": "Text Library",
        "selectLanguage": "Select language",
        "texts": "Texts",
        "page": "Page",
        "of": "of",
        "all": "All",
        "group": "Group",
        "language": "Language",
        "validFrom": "Valid From",
        "validTo": "Valid To",
        "name": "Name",
        "createdTime": "Created Time",
        "createdByUserName": "Created By UserName",
        "modifiedTime": "Modified Time",
        "modifiedByUserName": "Modified By UserName",
        "sortby": "Sort by",
        "ascending": "Ascending",
        "descending": "Descending",
        "copyText": "Copy text",
        "textHasExpired": "Text has expired.",
        "copied": "Copied!",
        "insertTextFromLibrary": "Insert Text from Library",
        "copyFullTextToClipboard": "Press ENTER to copy the text",
        "copyPartialTextToClipboard": "Press Shift + ENTER to view and copy parts of the text",
        "danish": "Danish",
        "english": "English",
        "finnish": "Finnish",
        "norwegian": "Norwegian",
        "swedish": "Swedish"
    },
    "distribution": {
        "distribution": "Distribution",
        "centralDistribution": "Central distribution",
        "localPrint": "Local print",
        "email": "Email",
        "archiveOnly": "Archive only",
        "successDocumentPublishment": "Success document publishment",
        "successDocumentDistribution": "Success document distribution",
        "generatingPdf": "Generating PDF...",
        "pleaseWaitProcessing": "Please wait while we process your request.",
        "download": "Download",
        "print": "Print",
        "close": "Close"
    },
    "discard": {
        "discardDocument": "Discard Document",
        "areYouSureToDiscardDocument": "Are you sure to discard document?"
    },
    "insertPoint": {
        "insertedText": "Inserted Text"
    },
    "inputFieldValidation": {
        "required": "Required",
        "atLeast": "At least",
        "atMost": "At most",
        "characterRequired": "character required",
        "invalid": "invalid"
    },
    "mandatoryFieldBanner": {
        "message": "This document got mandatory fields that hasn't been filled out.",
        "browse": "Browse",
        "moveDown": "Move to the next mandatory field that hasn't been filled out",
        "moveUp": "Move to the previous mandatory field that hasn't been filled out"
    },
    "breakTable": {
        "insertRowAbove": "Insert row above",
        "insertRowBelow": "Insert row below",
        "deleteRow": "Delete row",
        "moveUp": "Move up",
        "moveDown": "Move down"
    }
}